import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import { useHttpClient } from '@bonusly/http-client';

export interface Args {
	evaluation_id: string;
	sharedWithManager: boolean;
}

export const useFeedbackVisibility = (options: UseMutationOptions<unknown, unknown, Args> = {}) => {
	const http = useHttpClient('v2');

	return useMutation(
		(args: Args) => {
			return http.put(`constructive_feedback/feedback_visibility/${args.evaluation_id}`, {
				shared_with_manager: args.sharedWithManager,
			});
		},
		{ retry: false, ...options }
	);
};
